import React from 'react';
import { Icon } from '@/Components/Icon/Icon';
import { ControlIcons } from '@/Static/IconsRes';
import Button from 'devextreme-react/button';
import styles from './FilterBuilderButton.scss';
import { Tooltip } from '@/Components/Tooltip/Tooltip';
import { useLocalization } from '@/Hooks';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const FilterBuilderButton = ({ onClick, disabled }: Props): React.ReactElement => {
  const {
    common: {
      Actions: { FilterBuilder },
    },
  } = useLocalization();

  return (
    <Tooltip text={FilterBuilder}>
      <Button onClick={onClick} className={styles.button} disabled={disabled}>
        <Icon alt="filterBuilderIcon" src={ControlIcons.TableFilter} className={styles.icon} disabled={disabled} />
      </Button>
    </Tooltip>
  );
};
